import instance from "../../api";
import {IDynamicTableParams} from "components/DynamicTable";

export const getActs = (data: IDynamicTableParams) => {
    return instance().post("/conclusionAct/list", data)
        .then(response => response.data);
}

export const getAvailableColumns = () => {
    return instance().post("/conclusionAct/availableColumns")
        .then(response => response.data);
}

export const getAvailableGroupColumns = () => {
    return instance().post("/conclusionAct/availableGroupColumns")
        .then(response => response.data);
}
